import DOMPurify from 'dompurify';

// Elements that are never wanted in HTML coming from chat messages, bots or the backend:
// embedded documents (an iframe srcdoc runs script with the admin's origin), phishing forms and
// controls, and document-level tags. DOMPurify already drops <script> and on* handlers.
const FORBID_TAGS = [
  'base',
  'button',
  'embed',
  'form',
  'frame',
  'frameset',
  'iframe',
  'input',
  'link',
  'meta',
  'object',
  'option',
  'select',
  'style',
  'textarea',
];

export interface SanitizeHtmlOptions {
  // Keep inline `style` attributes. Only for markup the app builds itself around escaped
  // content (e.g. the agent trace bold labels); otherwise styles allow full-screen overlays.
  allowInlineStyles?: boolean;
}

export const sanitizeHtml = (
  html: unknown,
  { allowInlineStyles = false }: SanitizeHtmlOptions = {},
): string => {
  if (!html) return '';
  return DOMPurify.sanitize(String(html), {
    FORBID_TAGS,
    FORBID_ATTR: allowInlineStyles ? [] : ['style'],
    ADD_ATTR: ['target'],
  });
};
